import React, { useState, MutableRefObject, useEffect, useContext } from 'react'
import styled from 'styled-components'
import Sidebar from './Sidebar/Sidebar'
import Header from './Header/Header'
import { breakpoints } from '../../utils/constant'
import CustomBreadcrumbs from './breadcrumbs'
import LoadingWrapper from './LoadingWrapper'

const Container = styled.div`
    width:100%;
    height:100vh;
    display:flex;
`

const SidebarContainer = styled.div`
    width:260px;
    height:100%;
`

const RightContainer: ({ mobile, children }: { mobile?: Boolean, children: React.ReactNode }) => React.JSX.Element = styled.div`
    width:${props => props.mobile ? '100%' : 'calc(100% - 240px)'};
    height:100%;
    background: var(--light_bg);
`

const NavbarContainer = styled.div`
    width:100%;
    // height:65px;
    z-index:99;
    position:relative;
`

const ContentContainer = styled.div`
    width:100%;    
    padding: 15px;
    background: var(--light_bg);
`

// const ContentCard: ({ height }: { height: number }) => React.JSX.Element = styled.div`
//     width:100%;
//     background: #fff;
//     border-radius: 4px;
//     border-top: 1px solid var(--primary_color);
//     box-shadow: -2px -2px 10px rgba(0,0,0,0.1);
//     padding: 10px;
//     max-height: ${props => props.height};
//     overflow: auto;
// `

const ContentCard = (props: any) => {

    const [offset, setOffset] = useState(0)

    const contentContainer = () => document.querySelector('#content_card')

    React.useEffect(() => {
        setOffset((contentContainer() as HTMLElement)?.offsetTop)
    }, [contentContainer()])

    React.useEffect(() => {
    }, [offset])

    return <div style={{
        width: '100%',
        background: '#fff',
        borderRadius: '4px',
        borderTop: '1px solid var(--primary_color)',
        boxShadow: '-2px -2px 10px rgba(0,0,0,0.1)',
        padding: '10px 10px 20px 10px',
        overflow: 'auto',
        height: `calc(100vh - ${offset}px - 17px)`,
    }} id='content_card'>
        {props.children}
    </div>
}

const MobileLayout = (props: any) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false)

    return (
        <Container>
            <Sidebar mobile isOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)} />
            <RightContainer mobile>
                <NavbarContainer>
                    <Header openSidebar={() => setIsSidebarOpen(true)} />
                </NavbarContainer>
                <CustomBreadcrumbs />
                <ContentContainer>
                    <ContentCard >
                        {props.children}
                    </ContentCard>
                </ContentContainer>
            </RightContainer>
        </Container>
    )
}


const DesktopLayout = (props: any) => {

    return (
        <Container>
            <SidebarContainer>
                <Sidebar />
            </SidebarContainer>
            <RightContainer>
                <NavbarContainer>
                    <Header />
                </NavbarContainer>
                <CustomBreadcrumbs />
                <ContentContainer >
                    <ContentCard >
                        {props.children}
                    </ContentCard>
                </ContentContainer>
            </RightContainer>
        </Container>
    )
}

const Layout = (props: any) => {
    

    return <LoadingWrapper>
        {window.innerWidth > breakpoints.mobile ?
            <DesktopLayout {...props} /> :
            <MobileLayout {...props} />}
    </LoadingWrapper>
}

export default Layout